import React from 'react';
import { ContactUs } from '@fortress-technology-solutions/fortress-component-library/Organisms_Portal';
import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { useContactUs } from './index.hooks';

const ContactUsContainer = () => {
  const { onSubmit, isSuccessful, submitDisabled, ReactHookFormProps } =
    useContactUs();

  return (
    <Box id={'contactUsContainer'} component={'div'} padding={2}>
      <ContactUs
        onSubmit={onSubmit}
        isSuccessful={isSuccessful}
        submitDisabled={submitDisabled}
        ReactHookFormProps={ReactHookFormProps}
      />
    </Box>
  );
};

export default ContactUsContainer;
